module.exports = __webpack_public_path__ + "img/file-image.3dc060ce.svg";